export default __webpack_public_path__ + "static/waitingRoomAsleep-52fb686078617084419d52d0393202a9.svg";